<template>
  <div>
    <el-row style="margin-bottom: 15px">
      <el-col :span="customerId ? 18 : 24">
        <div style="font-size: 14px; margin: 5px 0">
          <span style="margin-right: 40px">合同总额（元）：{{amountFormat(Number(otherData.totalContractAmount) / 10000)}} 万</span>
          <span style="margin-right: 40px">已签约（元）：{{amountFormat(Number(otherData.totalSignContractAmount) / 10000)}}万</span>
          <span>已回款（元）：{{amountFormat(Number(otherData.totalFundedAmount) / 10000)}}万</span>
        </div>
      </el-col>
      <el-col :span="6" align="right" v-if="customerId">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="合同编号" min-width="130" align="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column v-if="businessId" label="签约客户" min-width="100" align="left" prop="customerName" >
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toUserDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column  v-if="customerId" label="商机" min-width="100" align="left" prop="businessName" >
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail(scope.row)">{{scope.row.businessName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" min-width="100" align="center" prop="contractTypeDesc" />
      <el-table-column label="合同状态" min-width="100" align="center" prop="contractStatusDesc" />
      <el-table-column label="总金额(元)" min-width="130" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.contractAmount) / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="已回款(元)" min-width="130" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.fundedAmount) / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" min-width="100" align="center" prop="assignUserName" />
      <el-table-column label="签约日期" min-width="100" align="center" prop="contractSignDate" />
      <el-table-column label="最新回款日期" min-width="100" align="center" prop="newestFundDate" />
    </el-table>
    <pagination v-if="total" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="queryList"/>
    <AddContractDialog ref="addContractDialogRef" @success="queryList"></AddContractDialog>
  </div>
</template>

<script>

import { getContractList } from "@/api/crm/contract";
import { amountFormat } from '@/utils/index'
import AddContractDialog from "@/views/crm/contract/addContractDialog";

export default {
  name: "ContractList",
  props: {
    customerId: {},
    customerName: {},
    businessId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat,
      total: 0,
      otherData: {
        totalContractAmount: 0, // 合同总额
        totalSignContractAmount: 0, // 已签约
        totalFundedAmount: 0, // 已回款
      },
      queryParams: {
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  created() {
    if (this.customerId || this.businessId) {
      this.queryList();
    }
  },
  components: {
    AddContractDialog
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    businessId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addContractDialogRef.open('customerId', this.customerId, this.customerName);
    },
    queryList () {
      this.loading = true;
      getContractList(Object.assign({
        customerId: this.customerId,
        businessId: this.businessId
      },
      this.queryParams)).then(response => {
        const {total, otherData, rows, msg, code} = response
        this.loading = false;
        if (code == 200) {
          this.dataList = rows || [];
          this.total = total
          this.otherData = otherData || {}
          this.$emit('after-query', this.dataList);
        } else {
          this.$message.error(msg || '合同列表获取异常')
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.msg || '合同列表获取异常')
      });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.id, "_blank")
    },
    toUserDetail (row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 详细按钮操作 */
    toBusinessDetail (row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank")
    },
  }
};
</script>
<style lang="scss" scoped>
  ::v-deep .pagination-container{
    padding: 10px 0px 32px !important;
  }
</style>
